"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
function periodicRequestSocket(createSocket) {
    const socket = createSocket();
    let interval = null;
    socket.addEventListener('open', startPeriodicRequests);
    socket.addEventListener('close', endPeriodicRequests);
    socket.addEventListener('error', endPeriodicRequests);
    function startPeriodicRequests() {
        interval = setInterval(sendPeriodicRequests, 15000);
        socket.removeEventListener('open', startPeriodicRequests);
    }
    function endPeriodicRequests() {
        if (interval !== null) {
            clearInterval(interval);
        }
        socket.removeEventListener('close', endPeriodicRequests);
        socket.removeEventListener('error', endPeriodicRequests);
    }
    function sendPeriodicRequests() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const resp = yield socket.request({ messageType: 'PeriodicRequest' }, 5000);
                if (((_a = resp.responseCode) === null || _a === void 0 ? void 0 : _a.name) !== 'success') {
                    throw new Error('Periodic request failed!');
                }
            }
            catch (e) {
                socket.close();
            }
        });
    }
    return socket;
}
exports.default = periodicRequestSocket;
//# sourceMappingURL=periodicRequestSocket.js.map